
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as exposed from '../exposed'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * ClientLoginType enum
 */
class ClientLoginType {
  /**
   * Initialize enum with a given value
   * @param {ClientLoginType|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof ClientLoginType) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!ClientLoginType}
   * @param {!ClientLoginType} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof ClientLoginType)) {
      throw new TypeError('Instance of ClientLoginType is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!ClientLoginType}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!ClientLoginType}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === ClientLoginType.UNKNOWN.value) {
      return 'UNKNOWN'
    }
    if (this.value === ClientLoginType.MOBILE_APP.value) {
      return 'MOBILE_APP'
    }
    if (this.value === ClientLoginType.WEB_TRADER.value) {
      return 'WEB_TRADER'
    }
    if (this.value === ClientLoginType.HTTPS_API.value) {
      return 'HTTPS_API'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!ClientLoginType}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!ClientLoginType}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!ClientLoginType} Created enum
   */
  static fromObject (other) {
    return new ClientLoginType(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
ClientLoginType.UNKNOWN = new ClientLoginType(0 + 0)
// noinspection PointlessArithmeticExpressionJS
ClientLoginType.MOBILE_APP = new ClientLoginType(0 + 1)
// noinspection PointlessArithmeticExpressionJS
ClientLoginType.WEB_TRADER = new ClientLoginType(0 + 2)
// noinspection PointlessArithmeticExpressionJS
ClientLoginType.HTTPS_API = new ClientLoginType(0 + 3)

export { ClientLoginType };

/**
 * Fast Binary Encoding ClientLoginType field model
 */
class FieldModelClientLoginType extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelClientLoginType}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelClientLoginType}
   * @param {ClientLoginType=} defaults Default value, defaults is new ClientLoginType()
   * @returns {!ClientLoginType} Result value
   */
  get (defaults = new ClientLoginType()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new ClientLoginType(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelClientLoginType}
   * @param {!ClientLoginType} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelClientLoginType };
